var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractsFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5871 6.99894H7.70205C7.29151 6.99882 6.89086 7.12504 6.55453 7.36048C6.21819 7.59591 5.96246 7.92915 5.82205 8.31494L2.06205 18.6569C1.92905 19.0219 2.02005 19.4309 2.29405 19.7059L2.58705 19.9989L9.00905 13.5769C9.00805 13.5509 9.00105 13.5249 9.00105 13.4989C9.00105 13.2023 9.08903 12.9123 9.25385 12.6656C9.41867 12.4189 9.65294 12.2267 9.92703 12.1131C10.2011 11.9996 10.5027 11.9699 10.7937 12.0278C11.0847 12.0856 11.3519 12.2285 11.5617 12.4383C11.7715 12.6481 11.9144 12.9153 11.9722 13.2063C12.0301 13.4973 12.0004 13.7989 11.8869 14.073C11.7733 14.3471 11.5811 14.5813 11.3344 14.7461C11.0877 14.911 10.7977 14.9989 10.5011 14.9989C10.4751 14.9989 10.4491 14.9919 10.4231 14.9909L4.00105 21.4129L4.29405 21.7059C4.42851 21.8407 4.59874 21.9342 4.78463 21.9753C4.97052 22.0164 5.1643 22.0035 5.34305 21.9379L15.6851 18.1769C16.0708 18.0365 16.4041 17.7808 16.6395 17.4445C16.875 17.1081 17.0012 16.7075 17.0011 16.2969V12.4119L19.0001 10.4139L13.5861 4.99994L11.5871 6.99894ZM19.9401 9.06094L14.9401 4.06094L17.0601 1.93994L22.0601 6.93994L19.9401 9.06094Z",
    fill: "#cf0a2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsFull);
export default __webpack_public_path__ + "static/media/contracts_full.c271699091b68ceacc3ad99c03dbc57a.svg";
export { ForwardRef as ReactComponent };